export default {
  title_1: '왜 하드웨어 지갑이 필요할까요?',
  desc_1_1:
    'Web3는 스마트 컨트랙트 위에 구축되어 있어 많은 사용자에게 다양한 위험을 야기합니다.',
  desc_1_2:
    '지갑을 만들거나 트랜잭션에 서명할 때 사용하는 휴대폰/컴퓨터는 침입, 악성코드, 클립보드 감시 등 알 수 없는 위험에 노출될 수 있습니다. Web3를 더 안전하게 이용하려면 전용 보안 장치가 도움이 됩니다.',
  desc_1_3: '그중 하나의 최선의 선택이 하드웨어 지갑입니다.',

  title_2: '하드웨어 지갑은 왜 안전한가요?',
  desc_2_1: '보안 칩',
  desc_2_2: '지갑 생성 지원',
  desc_2_3: '안전한 보관',
  desc_2_4: '키의 오프라인 보관/관리',
  desc_2_5: '해킹 회피',
  desc_2_6: '사기 예방',

  title_3: '왜 KeyPal 인가요?',
  desc_3_1: '듀얼 칩',
  desc_3_2:
    'KeyPal은 변조 방지 MCU와 SE 보안 칩의 듀얼 칩 보안 설계를 채택했습니다.',
  desc_3_3: '위조 방지 인증',
  desc_3_4:
    '각 KeyPal 기기는 생산 과정에서 고유 신원 인증서를 갖고, 후면에는 고유 일련번호가 레이저로 각인됩니다. 이 인증서는 온라인 위조 방지 검증에 사용됩니다.',
  desc_3_5: '민감한 데이터 전송 차단',
  desc_3_6:
    'KeyPal은 블루투스(이중 채널)와 USB로 앱과 통신합니다. 블루투스 통신 중 링크 계층에서는 민감 데이터를 전송하지 않아 블루투스에서의 가로채기를 방지합니다.',
  desc_3_7: 'PIN 코드',
  desc_3_8:
    '지갑 생성/복원 시 부팅 PIN을 설정해야 하며, 매번 부팅 시 올바른 PIN을 입력해야 사용 가능합니다. 연속해서 여러 번 오입력하면 기기는 공장 초기화되고 모든 지갑 데이터가 삭제되어 분실·도난·오사용 시 타인이 열람/사용하지 못하도록 보호합니다.',
  desc_3_9:
    'KeyPal은 BIP32/BIP39/BIP44 표준을 따르며, 오프라인 보안 환경에서 니모닉을 생성·관리·보호합니다. 블루투스 암호화, PIN 보호, 2.0인치 컬러 디스플레이로 각 서명 트랜잭션을 확인하여 "보는 대로 서명"을 보장하고 변조 및 중간자 공격을 방지합니다.',

  SE_desc_1: '1. 내장 진정난수 발생기',
  SE_desc_2: '2. 다중 보안 저장',
  SE_desc_3: '3. 시드가 칩 밖으로 나오지 않음',
  SE_desc_4: '4. 무차별 대입 공격 저항 및 외부 읽기 방지',
  MCU_desc_1: '1. 은행급 암호화',
  MCU_desc_2: '2. 시스템 보안 및 변조 감지',
  MCU_desc_3: '3. 외부 공격과 코드 주입에 대한 방어',
};
